/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { generate180DayData } from '../fn/admin/generate-180-day-data';
import { Generate180DayData$Params } from '../fn/admin/generate-180-day-data';
import { generate1YearData } from '../fn/admin/generate-1-year-data';
import { Generate1YearData$Params } from '../fn/admin/generate-1-year-data';
import { generate60DayData } from '../fn/admin/generate-60-day-data';
import { Generate60DayData$Params } from '../fn/admin/generate-60-day-data';
import { generateFinalData } from '../fn/admin/generate-final-data';
import { GenerateFinalData$Params } from '../fn/admin/generate-final-data';

@Injectable({ providedIn: 'root' })
export class AdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `generate60DayData()` */
  static readonly Generate60DayDataPath = '/api/Admin/Generate60DayData';

  /**
   * generate 60 day clientcarereport data for the current year and month.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `generate60DayData()` instead.
   *
   * This method doesn't expect any request body.
   */
  generate60DayData$Response(params?: Generate60DayData$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return generate60DayData(this.http, this.rootUrl, params, context);
  }

  /**
   * generate 60 day clientcarereport data for the current year and month.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `generate60DayData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  generate60DayData(params?: Generate60DayData$Params, context?: HttpContext): Observable<void> {
    return this.generate60DayData$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `generate180DayData()` */
  static readonly Generate180DayDataPath = '/api/Admin/Generate180DayData';

  /**
   * generate 180 day clientcarereport data for the current year and month.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `generate180DayData()` instead.
   *
   * This method doesn't expect any request body.
   */
  generate180DayData$Response(params?: Generate180DayData$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return generate180DayData(this.http, this.rootUrl, params, context);
  }

  /**
   * generate 180 day clientcarereport data for the current year and month.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `generate180DayData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  generate180DayData(params?: Generate180DayData$Params, context?: HttpContext): Observable<void> {
    return this.generate180DayData$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `generate1YearData()` */
  static readonly Generate1YearDataPath = '/api/Admin/Generate1YearData';

  /**
   * generate 1 year clientcarereport data for the current year and month.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `generate1YearData()` instead.
   *
   * This method doesn't expect any request body.
   */
  generate1YearData$Response(params?: Generate1YearData$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return generate1YearData(this.http, this.rootUrl, params, context);
  }

  /**
   * generate 1 year clientcarereport data for the current year and month.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `generate1YearData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  generate1YearData(params?: Generate1YearData$Params, context?: HttpContext): Observable<void> {
    return this.generate1YearData$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `generateFinalData()` */
  static readonly GenerateFinalDataPath = '/api/Admin/GenerateFinalData';

  /**
   * generate final clientcarereport data for the current year and month.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `generateFinalData()` instead.
   *
   * This method doesn't expect any request body.
   */
  generateFinalData$Response(params?: GenerateFinalData$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return generateFinalData(this.http, this.rootUrl, params, context);
  }

  /**
   * generate final clientcarereport data for the current year and month.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `generateFinalData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  generateFinalData(params?: GenerateFinalData$Params, context?: HttpContext): Observable<void> {
    return this.generateFinalData$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
